import { Component, OnInit } from '@angular/core';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { AppFilter, ConfirmModal, CommonServices } from 'src/modules/shared';
import {
  AuditTrailDetailModal,
  FieldChangeModal,
} from 'src/modules/features/admin/modals';
import { Location } from '@angular/common';
import { Subject } from 'rxjs';
import { map, take, takeUntil } from 'rxjs/operators';
import { NavigationStart, Router, ActivatedRoute } from '@angular/router';
import {
  NewEquipmentModal,
  EditEquipmentModal,
} from 'src/modules/features/contractor/modals';
import { CompanyService } from '../../../services';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-company-equipment',
  templateUrl: './company-equipment.component.html',
  styleUrls: ['./company-equipment.component.scss'],
})
export class CompanyEquipmentComponent implements OnInit {
  companyEquipments = [];
  projectId: string;
  unsubscribe$: Subject<boolean> = new Subject();
  success: any;
  error: any;
  pending: boolean;
  filter: AppFilter = new AppFilter();
  totalItems: number = 5;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;
  organizationId: string;
  searchFilter = {
    groupOp: 'AND',
    rules: [
      {
        field: 'equipName',
        op: 'cn',
        data: '',
      },
      {
        field: 'equipModelNumber',
        op: 'cn',
        data: '',
      },
      {
        field: 'yearOfManufacture',
        op: 'cn',
        data: '',
      },
    ],
  };
  message;
  redirect_url;
  applicationType;
  baseUrl: string = environment.API_SERVER;
  fileObj: any;
  files: any;
  equipmentTypes: Array<any> = [];
  officialEquipmentCount = 0;
  archivedEquipmentCount = 0;
  constructor(
    private modalService: SuiModalService,
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private companySvc: CompanyService,
    private commonSvc: CommonServices,
    private router: Router
  ) {
    this.organizationId = window.localStorage.getItem('organizationId');
    this.message = window.localStorage.getItem('message');
    this.applicationType = window.localStorage.getItem('application_type');
    this.redirect_url = window.localStorage.getItem('redirect_url');
    this.filter = new AppFilter({ sidx: 'dateCreated', rows: 10 });
    this.getEquipmentTypes();
    // this.activatedRoute.parent.params.subscribe((params) => {
    // 	this.projectId = params['id'];
    // });
    this.getPage(1);
    this.getEquipmentCount('ACTIVE');
    this.getEquipmentCount('ARCHIVED');
  }
  getEquipmentTypeName(id) {
    var type = this.equipmentTypes.find((type) => type.optionId == id);
    return type['optionName'];
  }
  getEquipmentTypes() {
    let searchFilter = {
      groupOp: 'AND',
      rules: [
        {
          field: 'optionType.optionTypeId',
          op: 'eq',
          data: 'equipment_type',
        },
      ],
    };
    let filter = new AppFilter({ sidx: 'optionId', rows: 10000 });
    filter.filters = JSON.stringify(searchFilter);
    this.commonSvc.getOption({ params: filter }).subscribe((res: any) => {
      this.equipmentTypes = res.rows;
    });
  }

  getPage(page) {
    this.filter.page = page;
    this.pending = true;
    this.companySvc
      .getCompanyEquipment({
        organizationId: this.organizationId,
        params: this.filter,
      })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.totalItems = +res.records;
          this.rows = this.filter.rows;
          this.companyEquipments = res['rows'];
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
        }
      );
  }

  getEquipmentCount(status) {
    this.pending = true;
    this.companySvc
      .getCompanyEquipmentByStatus({
        // .getCompanyEquipment({
        organizationId: this.organizationId,
        status: status,
        params: new AppFilter({rows: 1000}),
      })
      .subscribe(
        (res: any) => {
          if (status == 'ACTIVE') {
            this.officialEquipmentCount = +res.records;
          } else if (status == 'ARCHIVED') {
            this.archivedEquipmentCount = +res.records;
          }
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
              ? error.error.error
              : error.error
                ? error.error
                : error;
        }
      );
  }
  getArchivedEquipmentCount(): number {
    let count = 0;
    count = this.companyEquipments.filter(item => item.verificationStatus != 'ACTIVE').length;
    // console.log(count);
    return count;
  }

  detailCompany(event) {}
  deactivateCompany(event) {}
  serviceAccess(event) {}
  chatCompany(event) {}
  verifyCompany(event) {}

  deleteMulti() {}
  addCompany() {}
  viewCompany(event) {
    this.modalService
      .open(
        new AuditTrailDetailModal(
          'Row Data',
          'Are you sure you want to delete this Lot plan?',
          ModalSize.Mini
        )
      )
      .onApprove((payload) => {
        // this.addWorkflowGroup(payload);
      })
      .onDeny(() => {});
  }
  viewChangeField(event) {
    this.modalService
      .open(
        new FieldChangeModal(
          'Changed Field',
          'Are you sure you want to delete this Lot plan?',
          ModalSize.Mini
        )
      )
      .onApprove((payload) => {
        // this.addWorkflowGroup(payload);
      })
      .onDeny(() => {});
  }

  onDelete() {}

  delete(flow) {
    this.modalService
      .open(
        new ConfirmModal(
          'Delete Record',
          'Are you sure you want to delete this Record?',
          ModalSize.Mini
        )
      )
      .onApprove(() => {
        this.pending = true;
        this.companySvc
          .removeCompanyEquipment({ id: flow.organizationEquipmentId })
          .subscribe(
            (res) => {
              this.pending = false;
              this.success = 'Equipment removed successfully';
              this.getPage(1);
            },
            (error) => {
              this.pending = false;
              this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
            }
          );
      })
      .onDeny(() => {});
  }

  addEquipment() {
    this.modalService
      .open(
        new NewEquipmentModal(
          'Add New Equipment',
          { equipmentTypes: this.equipmentTypes },
          false,
          ModalSize.Mini
        )
      )
      .onApprove(() => {
        this.getPage(1);
      })
      .onDeny(() => {});
  }

  editEquipment(equipment) {
    this.modalService
      .open(
        new NewEquipmentModal(
          'Edit Equipment',
          { equipmentTypes: this.equipmentTypes, equipment: equipment },
          true,
          ModalSize.Mini
        )
      )
      .onApprove(() => {})
      .onDeny(() => {});
  }
  goBack() {
    this.location.back();
  }

  nullify() {
    this.success = '';
    this.error = '';
  }

  downloadTemplate() {
    var filename = `equipment-template.xlsx`;
    var element = document.createElement('a');
    let url = `${this.baseUrl}/organization/${this.organizationId}/eqipment-upload-template/?toFileName=${filename}`;
    window.open(url, '_blank');
  }

  uploadImage(event) {
    const files = event.target.files;
    if (!files) {
      return;
    }
    this.files = files;
    this.uploadTemplate('data');
  }

  uploadTemplate(data) {
    this.nullify();
    this.pending = true;
    const formData = new FormData();
    formData.append('file', this.files[0]);

    this.companySvc
      .uploadEquipmentTemplate({
        organizationId: this.organizationId,
        body: formData,
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.success = 'Equipment successfully uploaded';

          setTimeout(() => {
            this.success = '';
          }, 5000);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
              ? error.error.error
              : error.error
                ? error.error
                : error;
        }
      );
  }

  searchRecords(search) {
    let searchFilter = {
      groupOp: 'AND',
      rules: [
        {
          field: 'equipName',
          op: 'cn',
          data: '',
        },
        {
          field: 'equipModelNumber',
          op: 'cn',
          data: '',
        },
        {
          field: 'yearOfManufacture',
          op: 'cn',
          data: '',
        },
      ],
    };
    searchFilter.rules[0].data = search;
    searchFilter.rules[1].data = search;
    searchFilter.rules[2].data = search;
    this.filter.filters = JSON.stringify(searchFilter);
    this.getPage(1);
  }
  //handle sorting records
  sortRecords(search) {
    this.filter.sord = search;
    this.getPage(1);
  }

  //handles rows display
  displayRecords(row) {
    this.filter['rows'] = row;
    this.getPage(1);
  }

  nextPage(page: number) {
    //get and assign current page
    this.currentPage = page;
    this.getPage(this.currentPage);
  }

  ngOnInit(): void {
    this.router.events.pipe(takeUntil(this.unsubscribe$)).subscribe((event) => {
      if (
        event instanceof NavigationStart &&
        event.url != `/contractor/company/equipment`
      ) {
        localStorage.removeItem('message');
        localStorage.removeItem('application_type');
        localStorage.removeItem('redirect_url');
      }
    });
  }
}
